<template>
    <div class="page-aboutus">
        <div class="jumbo-wrapper aboutus">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">ABOUT US</p>
                    <h2 class="t42">
                        PIONEERING ENGRAVED
                        <br/>
                        BRICK PROJECTS SINCE 1987
                    </h2>
                    <p class="t20">Uniting communities brick-by-brick.</p>
                </div>
            </div>
        </div>
        <div class="box-content about-us">
            <div class="box-content-inner">
                <p class="basic-paragraph">
                    Fund Raisers, Ltd., a Boise-based, woman-owned company, was founded in 1987 and has since become
                    the leader in engraved brick projects for donor recognition and fundraising.
                    In 2016, after decades of working with community projects, professional sports teams,
                    colleges and universities, we unveiled our Fund Raisers Sports division.
                    While both
                    <a class="link" href="http://www.fundraiserssports.com/" target="_blank">
                        <strong><span>Fund Raisers Sports</span></strong>
                    </a> and
                    <router-link to="/" tag="a" class="link">
                        <strong><span>Fund Raisers, Ltd.</span></strong>
                    </router-link>
                    offer tremendous revenue and fund raising benefits,
                    Fund Raisers, Ltd. works with and supports the efforts of community organizations, such as schools,
                    parks, churches, military services, etc.
                </p>

                <p class="basic-paragraph">
                    As the premier provider of fund raising programs, our
                    <router-link to="/unmatched-quality">proprietary filler</router-link>
                    has proven to be an industry game-changer,
                    able to withstand any climate while retaining legibility. Our product quality is visible year after year,
                    with our programs gracing the most iconic facilities in the U.S., Canada, and Mexico.
                    Our product performs under high-traffic conditions at stadiums, schools, churches, parks,
                    military venues, and other community gathering spaces.
                </p>

                <p class="basic-paragraph">
                    Check out <router-link to="/our-work">our portfolio</router-link>
                    and see if you recognize any of these iconic locations!
                </p>
            </div>
        </div>
<!--
        <div class="about-person">
            <div class="about-person-left">
                <img src="images/About-Page/karenlockner.png" alt="">
            </div>
            <div class="about-person-right">
                <p class="basic-paragraph">
                    Karen Lockner built Fund Raisers, Ltd. as a "one-of-a-kind" company.
                    She pioneered engraved brick projects designed to enhance the donor experience with enduring,
                    personal messages which transform basic, concrete plazas and walls into public attractions,
                    all while generating revenue for the client.
                </p>
                <p class="basic-paragraph">
                    The success stories created by these projects are a result of Karen’s belief
                    in the power of listening to the customer.
                    In this business, her "We’ll figure it out" mantra has helped thousands of clients
                    and made the company successful for over 30 years.
                </p>
            </div>
        </div>-->
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'about-us',
        metaInfo: {
            title: 'About Us',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: 'Fund Raisers, Ltd. is the premier provider for thousands of community organizations in the U.S., Canada and Mexico.'
                }
            ]
        }
    }
</script>



// WEBPACK FOOTER //
// AboutUs.vue?3e38bc58